import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '@/shared/ui';

import styles from './ScoreBadge.module.scss';

type ScoreBadgeProps = {
  score: number;
  ariaLabel?: string;
  className?: string;
};

export const ScoreBadge: FC<ScoreBadgeProps> = ({
  score,
  ariaLabel,
  className,
}) => {
  const { formatNumber } = useIntl();

  return (
    <span
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
      data-component="transcriptor-score-badge"
      className={cn(styles.badge, className)}
    >
      <Icon name="starFilled" size={12} className={styles.icon} />
      {formatNumber(score, { maximumFractionDigits: 1 })}
    </span>
  );
};
